import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./DurationSwitcher.module.scss";
import {useDurationSwitcherLogic} from "./DurationSwitcher.logic";
import {DashboardTimeRangeOptionType} from "../store/IDashboardPageStore";

export interface IDurationSwitcherProps {
  changeSelectedRange: (selectRange: DashboardTimeRangeOptionType) => void;
  selectedRange: DashboardTimeRangeOptionType;
}

export const DurationSwitcher: VoidFunctionComponent<IDurationSwitcherProps> = ({changeSelectedRange, selectedRange}) => {
  const {getClassNameIfActive} = useDurationSwitcherLogic(selectedRange);

  return (
    <ol className={s.container}>
      <li className={getClassNameIfActive(`lastSevenDays`, s.active)}>
        <button onClick={() => changeSelectedRange(`lastSevenDays`)} aria-label={`Last 7 days`}>Last 7d</button>
      </li>
      <li className={getClassNameIfActive(`lastThirtyDays`, s.active)}>
        <button onClick={() => changeSelectedRange(`lastThirtyDays`)} aria-label={`Last 30 days`}>Last 30d</button>
      </li>
      <li className={getClassNameIfActive(`last365Days`, s.active)}>
        <button onClick={() => changeSelectedRange(`last365Days`)} aria-label={`Last 365 days`}>Last 365d</button>
      </li>
      <li className={getClassNameIfActive(`allTime`, s.active)}>
        <button onClick={() => changeSelectedRange(`allTime`)}>All time</button>
      </li>
    </ol>
  );
}

